/* RESPONSIBLE TEAM: team-workflows */
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';

export default class AppsAppOperatorRoute extends Route {
  @service router;

  beforeModel() {
    this.router.replaceWith('apps.app.automation');
  }
}
